module.exports = __webpack_public_path__ + "e5ebbe1adf961da3c5f736cedc44d269.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/netzbuehne04.jpg
// module id = 672
// module chunks = 0